export default __webpack_public_path__ + "static/media/xpo-c.c9eb32e5.svg";